export enum PreloadWarmUpStatus {
  Pending = 'pending',
  Ready = 'ready',
  Failed = 'failed',
}

export enum PreloadMessageSource {
  Host = 'checkout-preload-host',
  Viewer = 'checkout-preload-viewer',
}

export enum PreloadMessageType {
  LoadCart = 'loadCart',
  Ready = 'ready',
  WarmUpLoadFailed = 'warmUpLoadFailed',
  CartLoadFailed = 'cartLoadFailed',
}

export type LoadCartMessage = {
  source: PreloadMessageSource.Host;
  type: PreloadMessageType.LoadCart;
  payload: {cartId?: string};
};
